import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Typography,
  FormControl,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  TableRow,
  TableCell,
  TableContainer,
  TextField,
  Divider,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Loader, Select } from 'sputnik-ui'
import { fetchPayoutLicensedKey } from 'store/payoutsSlice'

export function PayoutTable({ 
  Wrapper, 
  formatDate, 
  visualFormatDate,
  }) {
  const minDate = '2025-05'
  const date = new Date()
  const formatMonth = (month) => {
    return month < 10 ? `0${month}` : month
  }
  const [endDate, setEndDate] = useState(`${date.getFullYear()}-${formatMonth(date.getMonth() + 2)}`)
  const [startDate, setStartDate] = useState(`${date.getFullYear()}-${formatMonth(date.getMonth() - 1)}`)
  const dispatch = useDispatch()
  const { t } = useTranslation(['analytics'])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(30)
  const states = [ {
      label: t('analytics:licensed_keys.all'),
      value: null,
    },
    {
      label:t("analytics:licensed_keys.state.pending"),
      value: 'pending'
    },
    {
      label: t("analytics:licensed_keys.state.payed_out"),
      value: 'payed_out'
    },
  ]
  const [state, setStates] = useState(states[0])

  useEffect(() => {
    const date = new Date()
    const startDateFormatted = startDate === '' ? minDate + '-01' : startDate + '-01'
    const endDateFormatted = endDate === '' ? `${date.getFullYear()}-${formatMonth(date.getMonth() + 2)}-01` : endDate + '-01'
    dispatch(fetchPayoutLicensedKey({startDate: startDateFormatted, endDate: endDateFormatted, page, limit, state: state.value}))
  }, [dispatch, startDate, endDate, page, limit, state])

  const keysPayout  = useSelector(({ payouts }) => payouts.payout_licensed_keys);

  if (keysPayout === null) {
    return <Loader />
  }

  return (
    <>
      <Wrapper style={{
        display: 'flex',
        flexDirection: 'column'}}>
        <Typography variant="h6">
          {t('analytics:licensed_keys.filter')}
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '100%',
          }}
        >
           <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              alignItems: 'flex-end',
              marginTop: 11,
            }}>
                 <div>
                   <Typography
                     style={{
                       padding: '0 5px 6px  ',
                       lineHeight: '20.3667px',
                     }}
                   >
                     {t('analytics:from')}
                   </Typography>
           
                   <Divider
                     style={{
                       width: 40,
                       backgroundColor: 'rgba(0, 0, 0, 0.45)',
                     }} //need fix
                   />
                 </div>
           
                 <TextField
                   id="date"
                   type="month"
                   inputProps={{
                     min: minDate,
                   }}
                   InputLabelProps={{
                     shrink: true,
                   }}
                   style={{
                     marginTop: '.325rem',
                   }}
                   name="start_date"
                   onChange={(e) => { setStartDate(e.target.value)}}
                   value={startDate}
                 />
                 <Divider
                   style={{
                     width: 30,
                     backgroundColor: 'rgba(0, 0, 0, 0.45)',
                   }} //need fix
                 />
                 <div>
                   <Typography
                     style={{
                       padding: '0 5px 6px  ',
                       marginLeft: 'auto',
                       lineHeight: '20.3667px',
                     }}
                   >
                     -
                   </Typography>
           
                   <Divider
                     style={{
                       width: 30,
                       backgroundColor: 'rgba(0, 0, 0, 0.45)',
                     }} //need fix
                   />
                 </div>
                 <div>
                   <Typography
                     style={{
                       padding: '0 5px 6px  ',
                       lineHeight: '20.3667px',
                     }}
                   >
                     {t('analytics:to')}
                   </Typography>
           
                   <Divider
                     style={{
                       width: 40,
                       backgroundColor: 'rgba(0, 0, 0, 0.45)',
                     }} //need fix
                   />
                 </div>
                 <TextField
                   type="month"
                   InputLabelProps={{
                     shrink: true,
                   }}
                   inputProps={{
                     min: minDate,
                   }}
                   style={{
                     marginTop: '.325rem',
                   }}
                   name="end_date"
                   onChange={(e) => { setEndDate(e.target.value)} }
                   value={endDate}
                 />
               </div>
            
           
          <FormControl
            component="fieldset"
            style={{
              flex: 1,
              minWidth: 200,
            }}
          >
            <Select
              name="kind"
              options={states}
              isMulti={false}
              cacheOptions
              selected={state}
              onChange={(o) => {
                setStates(o)
              }}
              placeholder={t('analytics:licensed_keys.kind_all')}
              style={{ width: '100%' }}
            /> 
          </FormControl>
        </div>
      </Wrapper>
      <TableContainer component={Wrapper}>
        <Table
          stickyHeader
          aria-label="simple table"
          style={{
            width: '100%',
            background: 'white',
            tableLayout: 'fixed',
          }}>
          <TableHead>
              <TableRow>
                <TableCell>
                  К выплате: {' '}
                  {keysPayout?.meta?.total_amount_to_pay}
                </TableCell>
                <TableCell>
                  Выплаченно: {' '}
                  {keysPayout?.meta?.total_amount_payed}
                </TableCell>
                <TableCell>{' '} </TableCell>
                <TableCell>{' '} </TableCell>
                <TableCell>{' '} </TableCell>
            </TableRow>
            <TableRow>
                <TableCell>
                  Период начисления
                </TableCell>
                <TableCell>
                  Дата начисления
                </TableCell>
                <TableCell>
                  Кол-во ключей
                </TableCell>
                <TableCell>
                  Сумма к выплате
                </TableCell>
                <TableCell>
                  Статус выплаты
                </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {keysPayout?.payout_licensed_keys?.map((p) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={p.uuid}
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  <TableCell component="th" scope="row" padding="dense">
                    {visualFormatDate(p.pay_period_start)} - {visualFormatDate(p.pay_period_end)} 
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {!!p.payed_out_at && visualFormatDate(p.payed_out_at)}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {p.key_count}
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    { p.total }
                  </TableCell>
                  <TableCell component="th" scope="row" padding="dense">
                    {t(`analytics:licensed_keys.state.${p.state}`)}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
                      
        </Table>
      </TableContainer>
      <TablePagination
        component={Wrapper}
        count={keysPayout?.meta?.total_count || 0}
        rowsPerPage={limit}
        rowsPerPageOptions={[30, 50, 100]}
        page={page}
        labelRowsPerPage="Строк на странице:"
        onChangePage={(e, page) => {
          setPage(page)
        }}
        onChangeRowsPerPage={(e) => {
          setPage(1)
          setLimit(e.target.value)
        }}
        style={{ background: 'white' }}
      />
    </>
  )
}
